import firebase from "firebase/app";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import softDeleteDocument from "astrid-firestore/src/api/documents/softDeleteDocument";
import useBucket from "astrid-hooks/src/useBucket";

import { useProfile } from "../../../../authentication/state/profile";
import useHasRole from "../../../../authorization/hooks/useHasRole";

export default function useExportDropdownMenuOptions() {
	const user = useProfile();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const hasRole = useHasRole();
	const isSuper = hasRole("owner", "admin");
	const { deleteFolder } = useBucket("earselect-exports");

	return (data) => {
		return [
			{
				text: t("view", "View"),
				hidden: !isSuper,
				action: () => {
					navigate(`./${data.id}`);
				},
			},
			{
				text: t("delete", "Delete"),
				action: async () => {
					await softDeleteDocument(firebase, data, user);
					await deleteFolder(data.id);
				},
			},
		];
	};
}
